// extracted by mini-css-extract-plugin
export default {"root":"BasePage_root__1xSoL","root_wrapper":"BasePage_root_wrapper__Qjtp8"};